import { useNavigate } from 'react-router-dom';
import { Result, Button } from 'antd';
import { useAuth } from '@/hooks/useAuth';
import { useRbac } from '@/hooks/useRbac';
import { ROUTES } from '@/constants/routes';

export interface PrivateRouteProps {
  element: React.ReactNode;
  /** Permission keys cần có (OR logic). Bỏ qua → chỉ cần authenticated. */
  requiredPermissions?: string[];
}

export function PrivateRoute({ element, requiredPermissions }: PrivateRouteProps) {
  const { isAuthenticated, user } = useAuth();
  const { hasAny, isLoading } = useRbac();
  const navigate = useNavigate();

  if (!isAuthenticated || !user) {
    // return <Navigate to={ROUTES.auth.login} replace />;
  }

  if (isLoading) {
    return null;
  }

  if (requiredPermissions && requiredPermissions.length > 0 && !hasAny(requiredPermissions)) {
    return (
      <Result
        status="403"
        title="403 Forbidden"
        subTitle="Bạn không có quyền truy cập vào chức năng này."
        extra={
          <Button type="primary" onClick={() => navigate(ROUTES.dashboard)}>
            Về tổng quan
          </Button>
        }
      />
    );
  }

  return <>{element}</>;
}
